function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M8.786,82.873l-.433-.433a.74.74,0,0,0-.526-.214.708.708,0,0,0-.52.214L4.5,85.247,1.693,82.44a.708.708,0,0,0-.52-.214.74.74,0,0,0-.526.214l-.427.433A.717.717,0,0,0,0,83.4a.687.687,0,0,0,.219.52L3.98,87.679a.687.687,0,0,0,.52.219.717.717,0,0,0,.526-.219l3.761-3.761A.708.708,0,0,0,9,83.4.74.74,0,0,0,8.786,82.873Z",
  transform: "translate(0 -82.226)"
});

var SvgArrowGrayDown = function SvgArrowGrayDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5.673,
    viewBox: "0 0 9 5.673",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowGrayDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-gray-down.f32eb091.svg";
export { ForwardRef as ReactComponent };